import { StyleConfig } from "@chakra-ui/react";

export const FormLabel: StyleConfig = {
  baseStyle: {
    fontWeight: "medium",
  },
};
